import { BusPage } from "components/busPage/BusPage";
import { BusPageConfigurationProvider } from "contexts/BusPageContext/BusPageConfigurationState";
import React from "react";

export const BusPageApp: React.FC = () => {
    return (
        <BusPageConfigurationProvider>
            <BusPage />
        </BusPageConfigurationProvider>
    );
};
